import React from 'react';
import './Contact.scss';
import contactShareIcon from '../assets/contactshare.svg';
import penIcon from '../assets/pen.svg';
import timeIcon from '../assets/time.svg';

const Contact: React.FC = () => {
  const email = 'ra-pwodppbc@pa.gov';

  return (
    <section className="contactsection">
      <div className="contactheader">
        <strong>Contact Us</strong>
      </div>
      <div style={{ paddingLeft: '2%' }}>
        <strong className="help">Need Help Using the MyPBC Portal?</strong>
        <p className="parahelp">If you encounter issues or have questions about system functionalities, please reach out via email:</p>
      </div>
      <hr />
      <div className="subsection">
        <div className="contactlist">
          <img className="iconImg" src={contactShareIcon} alt="Contact" />
          <div className="list">
            <span className="contactsubtitle">How to Contact Us:</span>
            <ul>
              <li>For inquiries related to PBC and scoring-specific questions, reach out to ODP: <a href={`mailto:${email}`}>{email}</a></li>
              <li>For system-specific questions or feedback, reach out to the MyPBC Portal team: <a href="mailto:odppassystem@deloitte.com">odppassystem@deloitte.com</a></li>
            </ul>
          </div>
        </div>
        <div className="contactlist">
          <img className="iconImg" src={penIcon} alt="Write" />
          <div className="list">
            <span className="contactsubtitle">What to Include in Your Email:</span>
            <ul>
              <li>The name of the application you have questions about (e.g., PBC Scoring Portal, P4P Insights Center)</li>
              <li>A brief description of your question or issue</li>
              <li>Screenshots of unexpected system behavior (if applicable)</li>
            </ul>
          </div>
        </div>
        <div className="contactlist">
          <img className="iconImg" src={timeIcon} alt="Time" />
          <div className="list">
            <span className="contactsubtitle">What to Expect:</span>
            <ul>
              <li>ODP/MyPBC Portal team will review your inquiry and get back to you as soon as possible</li>
              <li>All replies will be sent to the email address the inquiry originated from</li>
            </ul>
          </div>
        </div>
      </div>
      <hr />
      <span style={{ paddingLeft: '2%' }} className="sectionend">Thank you for using the MyPBC Portal!</span>
    </section>
  );
};

export default Contact;